<template>
	<div>
		<v-row justify="center" v-if="globalLoading">
			<v-col cols="12" sm="10" md="9" lg="8">
				<v-skeleton-loader type="card"></v-skeleton-loader>
			</v-col>
		</v-row>
		<template v-else>
			<checker v-if="isMobile && hasLodgingsToCheckToday" />
			<v-container v-if="personProps">
				<v-row
					justify="center"
					class="mx-2"
					:class="{
						routerViewDark: $vuetify.theme.isDark,
						routerViewLight: !$vuetify.theme.isDark,
					}"
				>
					<v-overlay v-if="saving" :value="saving">
						<v-progress-circular
							color="primary"
							indeterminate
							size="64"
						></v-progress-circular>
					</v-overlay>
					<!-- avatar -->
					<v-col cols="12" sm="10" md="9" lg="8">
						<label for="avatar" class="d-flex justify-center">
							<v-img
								v-bind="mainProps"
								style="position: relative;"
								rounded="circle"
								alt="avatar"
								class="pointer borderRadius"
								max-width="130px"
								:src="urlAvatar"
							>
								<v-progress-circular
									v-show="uploadindAvatar"
									indeterminate
									color="primary"
								></v-progress-circular>
								<div
									class="success"
									:style="
										uploadindAvatar ? 'margin-top: 22px;' : 'margin-top: 53px;'
									"
								>
									Actualizar
								</div>
							</v-img>
						</label>
						<v-file-input
							id="avatar"
							ref="avatar"
							class="pointer d-none"
							accept="image/jpeg, image/png, image/gif, image/jpg"
							@change="setAvatar"
						/>
					</v-col>
					<v-col
						cols="12"
						sm="10"
						md="9"
						lg="8"
						class="text-left text--secondary caption"
					>
						Datos personales
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8">
						<personal-data
							:person-props="person"
							:disableEdit="disableEdit"
							:is-user="true"
						/>
					</v-col>
					<v-col
						cols="12"
						sm="10"
						md="9"
						lg="8"
						class="text-left text--secondary caption"
					>
						Seguridad
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8">
						<v-text-field
							solo
							id="new-password-person"
							v-model.trim="securityData.newPassword"
							type="password"
							dense
							outlined
							filled
							label="Nueva contraseña"
							:error-messages="newPasswordErrors"
							@input="$v.securityData.newPassword.$touch()"
							@blur="$v.securityData.newPassword.$touch()"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8">
						<v-btn
							block
							small
							:loading="loadingNewPassword"
							:disabled="
								!!newPasswordErrors.length || !Boolean(securityData.newPassword)
							"
							color="success"
							@click="submitNewPassword"
						>
							Actualizar contraseña
						</v-btn>
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8"><v-divider /></v-col>
					<v-col
						cols="12"
						sm="10"
						md="9"
						lg="8"
						class="text-left text--secondary caption"
					>
						Contacto y ubicación
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8">
						<contact :disableEdit="disableEdit" :person-props="person" />
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8"><v-divider /></v-col>
					<v-col
						cols="12"
						sm="10"
						md="9"
						lg="8"
						class="text-left text--secondary caption"
					>
						Jornada
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8">
						<role :disableEdit="disableEdit" :person-props="person" />
					</v-col>
					<v-col
						cols="12"
						sm="10"
						md="9"
						lg="8"
						class="text-left text--secondary caption"
					>
						Revise sus entradas y salidas
					</v-col>
					<v-col cols="12" sm="10" md="9" lg="8">
						<histories />
					</v-col>
				</v-row>
			</v-container>
		</template>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import avatarDefault from '@/assets/default.png';
import { cloneDeep } from 'lodash';
import { validationMixin } from 'vuelidate';
import { minLength, maxLength, required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
	components: {
		Checker: () => import('@/components/persons/Checker'),
		PersonalData: () => import('@/components/persons/PersonalData'),
		Contact: () => import('@/components/persons/Contact'),
		Role: () => import('@/components/persons/Role'),
		Histories: () => import('@/components/persons/Histories'),
	},
	mixins: [validationMixin],
	data() {
		return {
			date: null,
			loadingNewPassword: false,
			securityData: {
				newPassword: '',
			},
			saving: false,
			uploadindAvatar: false,
			urlAvatar: '',
			mainProps: { blank: false, blankColor: '#777', width: 75, height: 75, class: 'm1' },
			person: { firstName: '', typeDocument: [], documents: [] },
		};
	},
	computed: {
		disableEdit() {
			return (
				Boolean(this.person.idCompany) &&
				!this.person.editable &&
				this.userProfile.idPerson === this.person._id
			);
		},
		newPasswordErrors() {
			const errors = [];
			if (!this.$v.securityData.newPassword.$dirty) return errors;
			!this.$v.securityData.newPassword.minLength && errors.push('Minimo 5 Caracteres');
			!this.$v.securityData.newPassword.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		hasTypeDocuments() {
			return (
				this.person.typeDocument &&
				this.person.typeDocument.length &&
				this.person.typeDocument.some(typeDocument => typeDocument)
			);
		},
		hasLodgingsToCheckToday() {
			const today = moment().format('YYYY-MM-DD');
			return this.lodgingsOfPersons.some(
				lodging =>
					lodging.setHistories &&
					moment(today).isSameOrAfter(moment(lodging.start)) &&
					moment(today).isSameOrBefore(moment(lodging.end))
			);
		},
		...mapGetters({
			personProps: 'Person/person',
			globalLoading: 'User/globalLoading',
			lodgingsOfPersons: 'Lodging/lodgingsOfPersons',
		}),
	},
	watch: {
		personProps() {
			this.initData();
		},
	},
	created() {
		this.initData();
	},
	methods: {
		async submitNewPassword() {
			this.$v.securityData.$touch();
			if (!this.$v.securityData.newPassword.$invalid) {
				this.loadingNewPassword = true;
				await this.updatePassword(this.securityData.newPassword);
				this.loadingNewPassword = false;
			}
		},
		initData() {
			this.person = cloneDeep(this.personProps);
			if (this.personProps) {
				if (this.personProps.avatar) this.urlAvatar = this.personProps.avatar;
				else this.urlAvatar = avatarDefault;
				this.person.typeDocument.map(typeDoc => ({ ...typeDoc, menu: false }));
			}
		},
		async setAvatar(file) {
			this.uploadindAvatar = true;
			this.person.avatar = file;
			this.urlAvatar = URL.createObjectURL(file);
			await this.putAvatar({ _id: this.person._id, avatar: file });
			this.uploadindAvatar = false;
		},
		async uploadDocument(index) {
			this.saving = true;
			let data = {
				_id: this.person._id,
				documents: this.person.documents[index],
				typeDocument: [...this.person.typeDocument],
			};

			data.typeDocument[index].done = true;
			data.typeDocument[index].isEditing = true;
			data.typeDocument[index].date = this.person.typeDocument[index].date;
			const person = await this.upload(data);
			this.setPerson(person);
			this.saving = false;
		},
		...mapMutations({
			setPerson: 'Person/setPerson',
		}),
		...mapActions({
			getPerson: 'Person/getPerson',
			putAvatar: 'Person/putAvatar',
			upload: 'Person/upload',
			updatePassword: 'User/updatePassword',
		}),
	},
	validations: {
		securityData: {
			newPassword: {
				minLength: minLength(5),
				maxLength: maxLength(100),
				required,
			},
		},
	},
};
</script>

<style lang="css" scoped>
.borderRadius {
	border-radius: 10px !important;
}
</style>
